var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Netmeeting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.73 40A3.819 3.819 0 0058 37.19V15.82A3.87 3.87 0 0054.19 12H21.82A3.87 3.87 0 0018 15.81v21.37A3.86 3.86 0 0019.27 40H8v4h59v-4H56.73zM54 37H22V16h32v21zm7.24 19.93a3.999 3.999 0 01-5.57 1l4.61-6.53a4 4 0 01.96 5.53zm-9.88-7.78L54.89 51A18.92 18.92 0 0138 60.62 18.92 18.92 0 0121.11 51l3.53-1.89c2.44 4.54 7.69 7.47 13.36 7.47 5.67 0 10.92-2.89 13.36-7.43zM52.74 60a4 4 0 11-7 3.79l7-3.79zM34 64h8a4 4 0 11-8 0zm-10.45-4l7 3.79a4 4 0 11-7-3.79zm-7.47-8.64l4.61 6.53a4.001 4.001 0 11-4.61-6.53z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Netmeeting.3d715480.svg";
export { SvgH1Netmeeting as ReactComponent };